module.exports = __webpack_public_path__ + "static/img/patentright-3.df0c920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/patentright-3.png
// module id = VBk+
// module chunks = 0